import { render, staticRenderFns } from "./ActivityPermissions.vue?vue&type=template&id=08ab83f2"
import script from "./ActivityPermissions.vue?vue&type=script&lang=js"
export * from "./ActivityPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports